/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="inventoryReturns.module.ts" />

module Meevo.Plugins.InventoryReturns {

    import ReturnReasonEnum = Meevo.Model.ReturnReasonEnum;
    import SortDirection = Meevo.Model.SortDirection;
    import ISearchColumn = Meevo.Model.ISearchColumn;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;

    export interface IParams {
        returnReasonList: Array<any>;
    }

    class InventoryReturnsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public searchContextCriteria = {};
        public returnReasonList = [
            { value: ReturnReasonEnum.Damaged, label: 'LABEL_DAMAGED' },
            { value: ReturnReasonEnum.Expired, label: 'LABEL_EXPIRED' },
            { value: ReturnReasonEnum.Return, label: 'LABEL_RETURN' }
        ];
        public inventoryReturnProductCriteria = {
            distributorId: null,
            filter: '',
            isInventoryTrackable: true
        };
        public params: IParams = {
            returnReasonList: this.returnReasonList
        };
        public displayNameColumnsCustom: ISearchColumn = {
            header: this.$translate.instant('LABEL_DATE'),
            fieldName: 'date',
            sortDirection: SortDirection.Ascending,
            width: 20
        };
        public coColumnsSustom: Array<ISearchColumn> = [
            { header: this.$translate.instant('LABEL_DISTRIBUTOR'), fieldName: 'distributor', sortDirection: null, width: 'auto' },
            { header: this.$translate.instant('LABEL_REFERENCE_NUMBER'), fieldName: 'referenceNumber', sortDirection: null, width: 33 },
            { header: this.$translate.instant('LABEL_AMOUNT_OF_RETURN'), fieldName: 'amountOfReturn', sortDirection: null, width: 33 }
        ];

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "$filter"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $filter: angular.IFilterService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        /**
       * Creates the context for editing/adding an item.
       * @return {}
       */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.INVENTORY_RETURNS).then(() => {
                this.busyService.stop();
                this.context = new InventoryReturnsContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.params,
                    this.busyService,
                    this.$timeout,
                    this.$translate,
                    this.$filter);

                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

        /**
         * User selected another distributor
         * @param distributor
         */
        distributorFilterChanged(criteria): void {
            if (criteria && criteria.distributor) {
                this.inventoryReturnProductCriteria.distributorId = criteria.distributor.id;

                // clean ProductVariant typeahead model
                criteria.inventoryProduct = null;
            } else {
                this.inventoryReturnProductCriteria.distributorId = null;
            }
        }

        closeCustomModal(): void {
            this.modalService.hide();
        }
    }

    angular.module("meevo.plugins.inventoryReturns")
        .controller("meevo.plugins.inventoryReturns.InventoryReturnsController", InventoryReturnsController);
}